import cx from 'classnames'
import { FC, useMemo } from 'react'
import { Icons } from 'src/components/Icon'
import { PictureProps } from 'src/components/Picture'
import RichText, { RichTextProps } from 'src/components/RichText'
import { motionGroup, separatorReveal, slideReveal } from 'src/hooks/useAppear'
import { MotionMask, MotionWrapper, SeparatorAbsolute } from 'src/theme/styled'

import * as SC from './styled'

export type QuoteProps = {
  className?: string
  richTextProps?: RichTextProps
  author?: string
  status?: string
  pictureProps?: PictureProps
}

const Quote: FC<QuoteProps> = ({
  className,
  richTextProps,
  author,
  status,
  pictureProps,
}) => {
  const { motions, variants } = useQuoteMotion()

  return (
    <SC.Container className={cx('Quote', className)} {...motions.container}>
      <SeparatorAbsolute
        aria-hidden
        role="separator"
        variants={variants.separator}
      />
      <SC.Blockquote>
        <SC.Mark icon={Icons.quote} variants={variants.mark} />
        <SC.Citation>
          {richTextProps && (
            <SC.RichTextWrapper>
              <MotionWrapper variants={variants.text}>
                <RichText {...richTextProps} />
              </MotionWrapper>
            </SC.RichTextWrapper>
          )}
          <MotionMask>
            <SC.Infos variants={variants.infos}>
              {author && <SC.Author>{author}</SC.Author>}
              {status && <SC.Status>{status}</SC.Status>}
            </SC.Infos>
          </MotionMask>
        </SC.Citation>
      </SC.Blockquote>
      {pictureProps && (
        <SC._Picture {...pictureProps} variants={variants.picture} />
      )}
    </SC.Container>
  )
}

const useQuoteMotion = () => {
  const motions = useMemo(
    () => ({
      container: motionGroup({}).motionProps,
    }),
    []
  )

  const variants = useMemo(
    () => ({
      separator: separatorReveal({}),
      mark: slideReveal({ delay: 0.2 }),
      picture: slideReveal({ delay: 0.32 }),
      text: slideReveal({ y: '100%', delay: 0.32 }),
      infos: slideReveal({ y: '100%', delay: 0.6 }),
    }),
    []
  )

  return { motions, variants }
}

export default Quote
